import Vue from 'vue'
import firebase from "firebase";

const state = {
  user: false,
  id: false,
  participant: false, 
  participants: [], 
  projectName: false,
  users: [], 
  chats: [],
  roomInstance: [],
  participantNotes: []
}



const actions = {
	fetchRoom({state, dispatch}, roomId){
		Vue.set(state, "id", roomId )
		firebase.firestore().doc("videoRooms/" + roomId ).onSnapshot( (doc) => {
			var data = doc.data();       
			for( var key in data ){
				Vue.set(state, key, data[key] )
			}   
			dispatch("fetchRoomParticipants")
		})
	},
	fetchRoomParticipants({state, commit}){
		var roomId = state.id;
		firebase.firestore().collection("videoRooms/" + roomId + "/participants").onSnapshot( (snap) => {
			snap.forEach( (doc) => {
				commit("SET_ANYTHING", { id: doc.id, data: doc.data(), reference: "participants" });
			})
		});
	},
	fetchRoomParticipant({state}, roomId){ 
		Vue.set(state, "id", roomId )
		var userId = firebase.auth().currentUser.uid;
		Vue.set(state, "user", userId )
		firebase.firestore().doc("videoRooms/" + roomId + "/participants/" + userId ).onSnapshot( (doc) => {
			if( doc.data() ){
				Vue.set( state, "participant", doc.data() );
			}
		});
	},
	fetchChats( {state, commit } ){
		var roomId = state.id;
		firebase.firestore().collection("videoRooms/" + roomId + "/chats").onSnapshot( (snap) => {
			snap.forEach( (doc) => {
				commit("SET_ANYTHING", { id: doc.id, data: doc.data(), reference: "chats" });
			})
		});	
	},
	fetchParticipantNotes( {state, commit } ){
		var roomId = state.id;
		firebase.firestore().collection("videoRooms/" + roomId + "/participants/" + state.participant.user + "/notes").onSnapshot( (snap) => {
			snap.forEach( (doc) => {
				commit("SET_ANYTHING", { id: doc.id, data: doc.data(), reference: "participantNotes" });
			})
		});	
	},
	getRoomInstance( { dispatch, state }, sid ){
		var roomId = state.id; 
		var first = state.participant.user; 
		firebase.firestore().collection("videoRooms/" + roomId + "/roomInstances").where("sid", "==", sid ).onSnapshot( (snap) => {
			if( snap.empty ){
				dispatch( "addDoc", {
					collection: "videoRooms/" + roomId + "/roomInstances",
					data: {sid: sid, firstParticipant: first }
				}, {root: true } )
			}
			snap.forEach( (doc) => {
				var data = doc.data();
				data.id = doc.id;
				Vue.set(state, "roomInstance", data );
			})
		});			
	},
}


const mutations = {
  SET_ONETHING(state, {ref, data}){
    Vue.set( state, ref, data );
  },
  SET_ANYTHING(state, {id, data, reference}) {
    if( !id ){ return; }
    if( typeof data == 'undefined') { return; }
    if( !state[reference] ) { return; }
    let index = state[reference].length;
    data.id = id;
    let exists = state[reference].find( p => p.id == id );
    if( exists ){
      index = state[reference].indexOf( exists )
    }
    Vue.set( state[reference], index, data );
  }, 

};


export default {
  // modules: {
  //   Projects,
  // },

  namespaced: true,
  state,
  actions,
  mutations,
};

